import React, { useEffect, useState } from "react";
import { Container, Box, Tabs, Tab } from "@mui/material";
import { ProyectosTable } from "./ProyectosTable"; // Importa correctamente el componente
import { AyudantiasInvestigacion } from "./AyudantiasInvestigacion"; // Importa el nuevo componente
import { useAppSelector } from "../../redux/hooks";
import { ProyectoData } from "../../interfaces/PROYECTOS/Proyectos";
import AlertService from "../../services/AlertService";
import ProyectoService from "../../services/ProyectoService";
import { PantallaCargaPage } from "../../pages/Modulos/PantallaCargaPage";

const alertaService = new AlertService();
const proyectoService = new ProyectoService();

export const ProyectosPage: React.FC = () => {
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");
    const [tabIndex, setTabIndex] = useState(0);
    const [ready, setReady] = useState(false);

    const [proyectos, setProyectos] = useState<Array<ProyectoData>>([]);

    const { isAuth, userData } = useAppSelector((state) => state.authReducer);

    const token = useAppSelector((state) => state.authReducer.token);

    //const token = userData.token;
    //const user = userData.netId;

    //const idpersona = userData.idpersona
    useEffect(()=>{
        if(isAuth){
            fetchData().then(()=>{
              setReady(true);
            });
        }
    },[token])

    const fetchData = async () => {
        try {
          alertaService.showLoading("Cargando Datos...");
          await proyectoService.GetProyectosByIdPersona(token)
            .then((data) => {
              if (data.status.isSuccessfully) {
                setProyectos(ProyectosAprobados(data.listData));
                alertaService.hideLoading();
              } else {
                alertaService.hideLoading();
                alertaService.alertaAdvertenciaList("ATENCIÓN", data.status.messages[0].split('|').filter(msg => msg.trim() !== ''));
                setProyectos([]);
              }
            })
            .catch((error) => {
              console.error(error)
              alertaService.hideLoading();
              setProyectos([]);
            });
          setReady(true);
        } catch (error) {
          console.error('Error:', error);
        }
      };


    function ProyectosAprobados(resp: Array<ProyectoData>): Array<ProyectoData> {
        let lista = resp.filter(x => x.estado != "Proyecto en la bandeja del director. Proyecto Nuevo.");
        return lista;
      }

    const filteredProyectos = proyectos.filter((proyecto) =>
        proyecto.titulo.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totalPages = Math.ceil(filteredProyectos.length / rowsPerPage);
    const displayedRows = filteredProyectos.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePageChange = (event: any, value: number) => {
        setCurrentPage(value);
    };

    const getIconColor = (estado: string) => {
        return estado === "EN EJECUCION" ? "success" : "disabled";
    };

    return (
      ready ?
        <Container maxWidth="lg" sx={{ paddingX: { xs: 2, md: 4 }, paddingY: { xs: 2, md: 3 }}}>
          <Box sx={{ padding: 3 }}>
                <ProyectosTable
                    rowsPerPage={rowsPerPage}
                    setRowsPerPage={setRowsPerPage}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    displayedRows={displayedRows}
                    totalPages={totalPages}
                    currentPage={currentPage}
                    handlePageChange={handlePageChange}
                    getIconColor={getIconColor}
                />
            </Box>
        </Container>
        :
        <PantallaCargaPage />
    );
};
